import * as R from 'ramda';

/**
 * Parsing rest data to our own data structures that
 * will be passed to the views via props
 */

export const mapLenderAccountFromJson = R.compose(json => {
  return {
    id: R.defaultTo(0, json['lender_account_id']),
    name: R.defaultTo(0, json['name']),
    repaymentDate: R.defaultTo("", json['next_repayment']),
    balance: R.defaultTo(0, json['balance']),
    totalAmount: R.defaultTo(0, json['total_amount'])
  };
}, R.defaultTo({}));

export const mapLenderAccountDetailFromJson = R.compose(json => {
  const jsonPreferences = R.defaultTo({}, json['preferences']);
  if (!R.isEmpty(jsonPreferences)) {
    const gradeJson = json['preferences']['grade']
    const grades = gradeJson === 'all' ? gradeJson : []
    if (R.is(Array, gradeJson)) {
      gradeJson.map((g) => {
        if (g === 'a') {
          return grades.push('low')
        } else if (g === 'b') {
          return grades.push('medium')
        } else if (g === 'c') {
          return grades.push('high')
        } else {
          return false
        }
      })
    }

    return {
      id: R.defaultTo(0, json['id']),
      name: R.defaultTo(0, json['name']),
      firstVirtualAccountNumber: R.pathOr(
        '',
        ['virtual_accounts', 0, 'virtual_account_number'],
        json
      ),
      investmentCategories: R.defaultTo(
        [],
        jsonPreferences['investment_category']
      ),
      loanAmount: R.pathOr('', ['loan_amount'], jsonPreferences),
      minInvestment: R.pathOr('', ['min_investment'], jsonPreferences),
      maxInvestment: R.pathOr('', ['max_investment'], jsonPreferences),
      tenor: R.pathOr('all', ['tenor'], jsonPreferences),
      riskCategory: R.defaultTo('all', grades),
      balance: R.defaultTo(0, json['balance']),
      invested: R.defaultTo(0, json['currently_invested']),
      realized_profit: R.defaultTo(0, json['realized_profit']),
      va_bni: R.defaultTo(0, json['va_bni']),
      va_bri: R.defaultTo(0, json['va_bri']),
      va_mandiri: R.defaultTo(0, json['va_mandiri']),
      va_bca: R.defaultTo(0, json['va_bca']),
      va_permata: R.defaultTo(0, json['va_permata'])
    };
  }
  return {}
}, R.defaultTo({}));

export const mapLoanFromJson = R.compose(json => {
  return {
    id: R.defaultTo(0, json['id']),
    contractId: R.defaultTo(0, json['contract_id']),
    investmentAmount: R.defaultTo('', json['investment_amount']),
    amount: R.defaultTo('', json['amount']),
    interestRate: R.defaultTo('', json['interest_rate']),
    status: R.defaultTo('', json['status']),
    loanType: R.defaultTo('', json['loan_type']),
    tenor: R.defaultTo('', json['tenor']),
    disbursementDate: R.defaultTo('', json['disbursed_date'])
  };
}, R.defaultTo({}));

export const mapLoanDetailFromJson = R.compose(json => {
  return {
    contractId: R.defaultTo(0, json['contractId']),
    borrowerType: R.defaultTo('', json['type']),
    status: R.defaultTo('', json['status']),
    numberOfInstallment: R.defaultTo(0, json['installments']['total']),
    installmentPaid: R.defaultTo(0, json['installments']['paid']),
    installmentAmount: R.defaultTo(0, json['installments']['installmentAmount']),
    disbursementDate: R.defaultTo('', json['disbursementDate']),
    nextRepaymentDate: R.defaultTo('', json['installments']['nextPayment']),
    completionDate: R.defaultTo('', json['installments']['estimatedCompletionDate']),
    isOverdue: R.defaultTo(false, json['installments']['overdue']['isOverdue']),
    startOverdueDate: R.defaultTo('', json['installments']['overdue']['startOverdueDate']),
    daysOverdue: R.defaultTo(0, json['installments']['overdue']['daysOverdue']),
    totalPenalty: R.defaultTo(0, json['installments']['overdue']['totalPenalty']),
    investmentAmount: R.defaultTo(0, json['investmentAmount']),
    currentProfit: R.defaultTo(0, json['profit']['current']),
    estimateProfit: R.defaultTo(0, json['profit']['estimate'])
  };
}, R.defaultTo({}));


export const mapAccountStatisticsFromJson = R.compose(json => {
  return {
    date: R.defaultTo('', json['date']),
    currentlyInvested: R.defaultTo('', json['currently_invested'])
  };
}, R.defaultTo({}));

export const mapAccountPreferences = R.compose(json => {
  return {
    name: R.defaultTo('', json['name']),
    loanAmount: R.defaultTo('', json['loanAmount']),
    minInvestment: R.defaultTo('', json['minInvestment']),
    maxInvestment: R.defaultTo('', json['maxInvestment']),
    tenor: R.defaultTo('all', json['tenor']),
    riskCategory: R.defaultTo('all', json['riskCategory'])
  }
}, R.defaultTo({}))
